import React from "react";

export default function Footer() {
  return (
    <footer className="py-4 bg-dark text-light text-center">
        <p className="mb-1">NLSA USA - I Play Professional Sports</p>
        <p className="small mb-0">© {new Date().getFullYear()} All Rights Reserved</p>
    </footer>
  );
}
